export const GET_ORDER_STATUS = 'GET_ORDER_STATUS';
export const GET_ORDER_STATUS_SUCCESS = 'GET_ORDER_STATUS_SUCCESS';
export const GET_ORDER_STATUS_FAILED = 'GET_ORDER_STATUS_FAILED';
